import { Box, List, ListItem, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomCircularProgress from "../../components/ui/customCircularProgress/customCircularProgress.component";
import { formatDateTime } from "../../utils";

export interface OnlineUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  full_name: string;
  last_activity_at: string;
}

interface OnlineUsersListProps {
  users: OnlineUser[];
  loading: boolean;
  error: string | null;
}

export const OnlineUsersList = ({ users, loading, error }: OnlineUsersListProps) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={3}>
        <CustomCircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      </Box>
    );
  }

  if (users.length === 0) {
    return (
      <Box p={2}>
        <Typography variant="body2" color="text.secondary">
          {t("No users are online right now.")}
        </Typography>
      </Box>
    );
  }

  return (
    <List disablePadding>
      {users.map((user) => (
        <ListItem key={user.id} disablePadding sx={{ py: 1 }}>
          <Paper variant="outlined" sx={{ p: 2, width: "100%", borderRadius: "var(--defaultRadius)" }}>
            <Typography variant="subtitle2" fontWeight={600}>
              {user.full_name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
              {t("Last activity")}: {formatDateTime(user.last_activity_at)}
            </Typography>
          </Paper>
        </ListItem>
      ))}
    </List>
  );
};
